export default {
    "aws_project_region": "us-west-1",
    "aws_appsync_graphqlEndpoint": "https://pcaqcd2q6ndslooczksv22yv7a.appsync-api.us-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-2fdy56offna7zkbbsumt5fgyv4"
};